import React from "react";
 
const TabContent = (props: TabContentProps) => {
  if (props.activeTab !== props.id) { return null };

  return (
    <div className="TabContent">
      { props.children }
    </div>
  );
};
 
export default TabContent;

interface TabContentProps{
  id:string, 
  activeTab:string, 
  children: React.ReactNode
}